import React, {useState, useRef} from "react";
import {useForm} from "react-hook-form";
import ReCAPTCHA from "react-google-recaptcha";
import {GoogleCaptchaKey} from "../../../config/client-config";

import "../../../css/space-form.css";
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {useTranslation} from "react-i18next";

// Your modular input components
import {
    DynamicInputSelect,
    InputText,
    InputTextArea,
    InputEmail,
} from '../../../utils/dynamicForm';
const FormOneRow = ({children}) => <div className="form-row-1col">{children}</div>;

const FormTwoRows = ({children}) => <div className="form-row-2cols">{children}</div>;

const apiUrl = process.env.REACT_APP_BACKEND_URL || "https://api.heriscope.communitism.space";
const RECAPTCHA_SITE_KEY = GoogleCaptchaKey;

const usageOptions = [
    {value: 'residential', label: 'Κατοικία'},
    {value: 'commercial', label: 'Εμπορική'},
    {value: 'other', label: 'Άλλο'}
];
//
// const roofConditionOptions = [
//     {value: 'good', label: 'Καλή'},
//     {value: 'moderate', label: 'Μέτρια'},
//     {value: 'bad', label: 'Κακή'}
// ];
//
// const roofTypeOptions = [
//     {value: 'tile', label: 'Κεραμοσκεπής'},
//     {value: 'flat', label: 'Επίπεδη'},
//     {value: 'other', label: 'Άλλο'}
// ];

function SpaceForm() {
    const {
        register,
        handleSubmit,
        formState: {errors},
        watch,
        reset
    } = useForm();
    const accepted = watch("accepted");

    const {t} = useTranslation();
    const modalRef = useRef(null);
    const [showForm, setShowForm] = useState(false);
    const [message, setMessage] = useState(null);
    const recaptchaRef = useRef(null);

    const onSubmit = async (data) => {
        let recaptchaToken = '';
        try {
            recaptchaToken = await recaptchaRef.current.executeAsync();
        } catch (err) {
            console.error("ReCAPTCHA Error:", err);
            toast.error("ReCAPTCHA failed. Please refresh and try again.");
            return;
        }

        try {
            const requestOptions = {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({ recaptchaToken, data }),
            };

            const response = await fetch(apiUrl + '/api/submit/spaces', requestOptions);

            if (response.ok) {
                setShowForm(false);
                const responseData = await response.json();
                setMessage(responseData.message || "Submitted successfully.");
                toast.success(t("Thank you for your submission! We will review it shortly."));
                reset();
            } else {
                const errorData = await response.json();
                setMessage(errorData.message || t("An error occurred"));
                toast.error(t("Submission failed."));
            }
        } catch (error) {
            console.error("Submission Error:", error);
            toast.error(t("An unexpected error occurred."));
        }
    };

    const openForm = (e) => {
         e?.stopPropagation?.();
         setShowForm(true);
     };
    const closeForm = () => setShowForm(false);
    //
    // const handleButtonClick = () => {
    //     setShowForm(!showForm);
    // };
    //
    // const handleCloseButtonClick = () => {
    //     handleButtonClick();
    // };

    return (
        <div className={`space-form-container ${showForm ? 'add-form' : ''}`}>
            <div className="space-form-add-background-block" onClick={closeForm} />
            <div className="space-form-add-button-block" onClick={openForm}>

            <img
                className="space-form-button-image"
                src='/img/ICONS_plus.png'
                alt="Thumbnail"
                onClick={openForm}
            />
            <div className="space-form-add-text-block"
                 onClick={openForm}>{t("ΠΡΟΣΘΗΚΗ ΧΩΡΟΥ")}</div>

        </div>

            <div className="space-form">
                <ToastContainer/>
                <div className="space-form-block" ref={modalRef}>
                    <div className="space-form-title">{t("Νέα Αίτηση Καταγραφής")}</div>
                    <div className="space-form-close-button" onClick={closeForm}>X</div>

                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="space-form-inputs-block">

                            <div className="space-form-block-recaptcha">
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    size="invisible"
                                    sitekey={RECAPTCHA_SITE_KEY}
                                />
                            </div>
                            <FormOneRow>

                                {InputText({
                                    register,
                                    errors,
                                    placeholder: "π.χ. Βουτάδων 15, 13435, Μεταξουργείο",
                                    label: t("Διεύθυνση"),
                                    name: 'address',
                                    isRequired: true
                                })}
                            </FormOneRow>

                            <FormOneRow>

                                {InputText({
                                    register,
                                    errors,
                                    placeholder: "",
                                    label: t("Τοποθεσία Google Maps"),
                                    name: 'glocation',
                                    isRequired: true
                                })}
                            </FormOneRow>

                            <FormTwoRows>

                                {DynamicInputSelect({
                                    register,
                                    errors,
                                    label: t("Χρήση"),
                                    name: 'usage',
                                    isRequired: true,
                                    placeholder: t("Επιλέξτε"),
                                    data: usageOptions,
                                    value: 'label',
                                    id: 'value',
                                    icons: false
                                })}
                                {InputText({
                                    register,
                                    errors,
                                    placeholder: "0",
                                    label: t("Αριθμός ορόφων"),
                                    name: 'floors',
                                    isRequired: false
                                })}

                            </FormTwoRows>
                            {/*<FormTwoRows>*/}

                            {/*    {DynamicInputSelect({*/}
                            {/*        register,*/}
                            {/*        errors,*/}
                            {/*        label: t("Κατάσταση στέγης"),*/}
                            {/*        name: 'roofCondition',*/}
                            {/*        isRequired: false,*/}
                            {/*        placeholder: t("Επιλέξτε"),*/}
                            {/*        data: roofConditionOptions,*/}
                            {/*        value: 'label',*/}
                            {/*        id: 'value',*/}
                            {/*        icons: false*/}
                            {/*    })}*/}

                            {/*    {DynamicInputSelect({*/}
                            {/*        register,*/}
                            {/*        errors,*/}
                            {/*        label: t("Είδος στέγης"),*/}
                            {/*        name: 'roofType',*/}
                            {/*        isRequired: false,*/}
                            {/*        placeholder: t("Επιλέξτε"),*/}
                            {/*        data: roofTypeOptions,*/}
                            {/*        value: 'label',*/}
                            {/*        id: 'value',*/}
                            {/*        icons: false*/}
                            {/*    })}*/}
                            {/*</FormTwoRows>*/}
                            <FormOneRow>

                                {InputTextArea({
                                    register,
                                    errors,
                                    placeholder: "",
                                    label: t("Παρατηρήσεις"),
                                    name: 'notes',
                                    isRequired: false
                                })}
                            </FormOneRow>
                            <FormOneRow>
                                {InputText({
                                    register,
                                    errors,
                                    placeholder: "",
                                    label: t("Όνομα"),
                                    name: 'userName',
                                    isRequired: false
                                })}
                            </FormOneRow>
                            <FormTwoRows>

                                {InputEmail({
                                    register,
                                    errors,
                                    placeholder: "",
                                    label: t("Email"),
                                    name: 'userEmail',
                                    isRequired: false
                                })}

                                {InputText({
                                    register,
                                    errors,
                                    placeholder: "",
                                    label: t("Αριθμός Τηλεφώνου"),
                                    name: 'userPhone',
                                    isRequired: false
                                })}
                            </FormTwoRows>
                            <FormOneRow>

                                {InputText({
                                    register,
                                    errors,
                                    placeholder: "",
                                    label: t("Ιδιότητα - Σχέση με το κτήριο"),
                                    name: 'userRelation',
                                    isRequired: false
                                })}

                            </FormOneRow>
                            <FormOneRow>
                                <div className="disclaimer-form-send">
                                    <p>Θέλουμε να αναδείξουμε τη συμβολή σου!</p>
                                    Βοήθησες να γίνει η βάση δεδομένων πιο πλούσια, προσθέτοντας πληροφορίες ή ένα νέο
                                    κτίριο πολιτιστικής κληρονομιάς.
                                    <p>Θα θέλαμε να αναγνωρίσουμε τη φροντίδα σου για την πόλη!</p>
                                    <p>Θα ήθελες το όνομά σου να εμφανίζεται στο site ως φροντιστής/φροντίστρια
                                        (care-giver)
                                        αυτού του κτιρίου;
                                        (Μπορείς πάντα να επιλέξεις να παραμείνεις ανώνυμ@)
                                    </p>
                                </div>
                            </FormOneRow>

                            {message && (
                                <p className={message.includes("added") ? "success-message" : "error-message"}>
                                    {message}
                                </p>
                            )}
                            <div className="form-checkbox-maps">
                                <label>
                                    <input type="checkbox" {...register("accepted", {required: true})} />
                                    {t("Έχω διαβάσει και αποδέχομαι την Πολιτική Απορρήτου.")}
                                </label>
                                {errors.accepted && (
                                    <span
                                        className="submit-error-validation">{t("Απαιτείται αποδοχή πριν την υποβολή.")}</span>
                                )}
                                <p>
                                    ➡ {t("Δείτε την")} <a href="/privacy" target="_blank"
                                                          rel="noopener noreferrer">{t("Πολιτική Απορρήτου")}</a>.
                                </p>
                            </div>
                        </div>
                        <input type="submit" value={t("Καταχώρηση")} disabled={!accepted}/>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default SpaceForm;
